// ══════════════════════════════════════════════════════════════
// AUTH MODAL TEMPLATE (GOOGLE 1-CLICK AUTHENTICATION)
// ══════════════════════════════════════════════════════════════

export function getAuthModalTemplate() {
  return `
  <!-- ══════════════════════════════════════════════════════════════
       MODAL: AUTH MODAL (ĐĂNG NHẬP / ĐĂNG KÝ GOOGLE 1-CHẠM)
       ══════════════════════════════════════════════════════════════ -->
  <div id="auth-modal"
    class="fixed inset-0 z-[150] hidden items-center justify-center p-3 sm:p-4 bg-slate-950/80 backdrop-blur-md overflow-y-auto transition-opacity duration-300">
    <div
      class="relative w-full max-w-sm bg-white rounded-3xl shadow-2xl overflow-hidden my-auto flex flex-col animate-slide-up border border-sky-100">
      
      <!-- Modal Header with Close -->
      <div class="flex items-center justify-between px-6 pt-5 pb-3 border-b border-gray-100">
        <div class="flex items-center gap-2.5">
          <div class="w-9 h-9 rounded-xl bg-gradient-to-tr from-primary-600 to-sky-500 flex items-center justify-center shadow-sm text-white">
            <svg class="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"/>
              <circle cx="12" cy="7" r="4"/>
            </svg>
          </div>
          <div>
            <span class="font-bold text-gray-900 text-base">Tài khoản Thợ Điện Xanh</span>
            <p class="text-[11px] text-gray-500">Đăng nhập thành viên thodienxanh.com</p>
          </div>
        </div>
        <button id="close-auth-modal-btn"
          class="p-2 text-gray-400 hover:text-gray-600 rounded-full hover:bg-gray-100 transition-colors cursor-pointer"
          aria-label="Đóng">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M18 6 6 18" />
            <path d="m6 6 12 12" />
          </svg>
        </button>
      </div>

      <!-- Google Fast Login Body -->
      <div class="p-6 sm:p-7 space-y-5 text-center">
        <!-- Hero Google Icon Badge -->
        <div class="w-16 h-16 mx-auto rounded-3xl bg-gradient-to-tr from-sky-50 via-primary-50 to-sky-100 border border-sky-200 flex items-center justify-center shadow-inner">
          <svg class="w-8 h-8" viewBox="0 0 24 24">
            <path fill="#4285F4"
              d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" />
            <path fill="#34A853"
              d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" />
            <path fill="#FBBC05"
              d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.06H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.94l2.85-2.22.81-.63z" />
            <path fill="#EA4335"
              d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.06l3.66 2.84c.87-2.6 3.3-4.52 6.16-4.52z" />
          </svg>
        </div>

        <div class="space-y-1">
          <h3 class="text-lg font-extrabold text-gray-900">Đăng Nhập Với Google</h3>
          <p class="text-xs text-gray-500 leading-relaxed">
            Đăng nhập & đăng ký 1 chạm. Tự động đồng bộ lịch sử đặt lịch và nhận voucher VIP.
          </p>
        </div>

        <!-- Member benefits -->
        <div class="bg-sky-50/80 border border-sky-100 rounded-2xl p-3.5 text-left space-y-2 text-xs text-gray-700">
          <div class="flex items-center gap-2 font-semibold text-gray-900">
            <span class="text-primary-600 font-bold">✓</span> Tra cứu lịch sử & tiến độ KTV thời gian thực
          </div>
          <div class="flex items-center gap-2 font-semibold text-gray-900">
            <span class="text-primary-600 font-bold">✓</span> Tự động lưu thông tin địa chỉ & nhắc lịch định kỳ
          </div>
          <div class="flex items-center gap-2 font-semibold text-gray-900">
            <span class="text-primary-600 font-bold">✓</span> Nhận ngay voucher giảm 10% - 15% cho thành viên
          </div>
        </div>

        <!-- Google Login Button -->
        <button type="button" id="btn-quick-google"
          class="w-full flex items-center justify-center gap-3 py-3.5 px-5 bg-white hover:bg-slate-50 text-gray-800 font-bold text-sm rounded-2xl border-2 border-slate-200 hover:border-primary-400 shadow-md hover:shadow-lg transition-all duration-200 active:scale-[0.99] cursor-pointer">
          <svg class="w-5 h-5 shrink-0" viewBox="0 0 24 24">
            <path fill="#4285F4"
              d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" />
            <path fill="#34A853"
              d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" />
            <path fill="#FBBC05"
              d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.06H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.94l2.85-2.22.81-.63z" />
            <path fill="#EA4335"
              d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.06l3.66 2.84c.87-2.6 3.3-4.52 6.16-4.52z" />
          </svg>
          <span id="btn-quick-google-text">Đăng nhập bằng Google</span>
        </button>

        <p class="text-[10px] text-gray-400 font-medium">
          🔒 Google OAuth 2.0 • Bảo mật an toàn tuyệt đối
        </p>
      </div>

    </div>
  </div>
  `;
}
